"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _Spinner = _interopRequireDefault(require("../common/Spinner"));
var _truncatedText = require("@design/ui/truncated-text");
var _promptHelpers = require("../../utils/prompt-helpers");
var _promptAccess = require("@common/utils/promptAccess");
var _branding = require("../../utils/branding");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PromptsTab = function PromptsTab(_ref) {
  var prompts = _ref.prompts,
    isLoading = _ref.isLoading,
    currentUserId = _ref.currentUserId,
    _ref$emptyMessage = _ref.emptyMessage,
    emptyMessage = _ref$emptyMessage === void 0 ? "No prompts found" : _ref$emptyMessage,
    onViewPrompt = _ref.onViewPrompt,
    onDeletePrompt = _ref.onDeletePrompt,
    onShareOpen = _ref.onShareOpen,
    onClickPrompt = _ref.onClickPrompt,
    onPublishPrompt = _ref.onPublishPrompt,
    _ref$showDescription = _ref.showDescription,
    showDescription = _ref$showDescription === void 0 ? false : _ref$showDescription;
  var groupedPrompts = (0, _react.useMemo)(function () {
    var groups = new Map();
    prompts.forEach(function (prompt) {
      var _prompt$path;
      var topCategory = ((_prompt$path = prompt.path) === null || _prompt$path === void 0 ? void 0 : _prompt$path.split("/")[0]) || "Uncategorized";
      if (!groups.has(topCategory)) {
        groups.set(topCategory, []);
      }
      groups.get(topCategory).push(prompt);
    });
    var sortedEntries = Array.from(groups.entries()).sort(function (_ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 1),
        a = _ref4[0];
      var _ref5 = _slicedToArray(_ref3, 1),
        b = _ref5[0];
      if (a === "Uncategorized") return 1;
      if (b === "Uncategorized") return -1;
      return a.localeCompare(b);
    });
    var sorted = new Map();
    var _iterator = _createForOfIteratorHelper(sortedEntries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          category = _step$value[0],
          items = _step$value[1];
        sorted.set(category, _toConsumableArray(items).sort(function (a, b) {
          var aName = (a.name || a.content || "").toLowerCase();
          var bName = (b.name || b.content || "").toLowerCase();
          return aName.localeCompare(bName);
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return sorted;
  }, [prompts]);
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center justify-center h-32",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
        size: 24
      })
    });
  }
  if (prompts.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-center py-8 text-[#686766] text-[13px]",
      children: emptyMessage
    });
  }
  var branding = (0, _branding.getBranding)();
  var getPromptTypeIcon = function getPromptTypeIcon(prompt) {
    if (!(0, _promptHelpers.isUserPrompt)(prompt)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: branding.managedIcon,
        alt: "Managed by ".concat(branding.name),
        className: "w-4 h-4 flex-shrink-0"
      });
    }
    if ((0, _promptAccess.isPromptSharedWithCaller)(prompt, currentUserId)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.GroupIcon, {
        width: 16,
        height: 16,
        className: "text-[#6B7280] flex-shrink-0"
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.PersonIcon, {
      width: 16,
      height: 16,
      className: "text-[#6B7280] flex-shrink-0",
      "data-sentry-element": "PersonIcon",
      "data-sentry-component": "getPromptTypeIcon",
      "data-sentry-source-file": "PromptsTab.tsx"
    });
  };
  var entries = Array.from(groupedPrompts.entries());
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-px",
    "data-sentry-component": "PromptsTab",
    "data-sentry-source-file": "PromptsTab.tsx",
    children: [entries.map(function (_ref6, sectionIndex) {
      var _ref7 = _slicedToArray(_ref6, 2),
        category = _ref7[0],
        categoryPrompts = _ref7[1];
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col",
        children: [sectionIndex > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "w-full h-px bg-[#E1E5E8]"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "px-3 py-2.5",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-sm font-semibold leading-normal tracking-[0.01em] text-foreground",
            children: category
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex flex-col",
          children: categoryPrompts.map(function (prompt) {
            var _prompt$description;
            var description = showDescription ? ((_prompt$description = prompt.description) === null || _prompt$description === void 0 ? void 0 : _prompt$description.trim()) || null : null;
            var _ref8 = (0, _promptHelpers.isUserPrompt)(prompt) ? (0, _promptAccess.promptRowActions)(prompt, currentUserId, onPublishPrompt !== undefined) : _promptAccess.NO_PROMPT_ROW_ACTIONS,
              canShare = _ref8.canShare,
              canPublish = _ref8.canPublish,
              canEdit = _ref8.canEdit,
              canDelete = _ref8.canDelete,
              hasActions = _ref8.hasActions;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              role: "button",
              tabIndex: 0,
              className: "group flex items-center gap-[10px] min-h-[40px] py-[8px] pl-[8px] pr-[4px] cursor-pointer hover:bg-background-primary-canvas transition-colors rounded-lg",
              onClick: function onClick() {
                return onClickPrompt(prompt);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.target !== e.currentTarget) return;
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onClickPrompt(prompt);
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "flex-1 min-w-0 flex flex-col justify-center",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "text-base font-normal leading-normal tracking-[0.01em] text-foreground truncate",
                  children: prompt.name || prompt.content
                }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedText.TruncatedText, {
                  className: "text-caption text-muted-foreground fit-wrap line-clamp-2",
                  children: description
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "grid flex-shrink-0 items-center justify-items-end",
                children: [hasActions && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "[grid-area:1/1] flex items-center gap-1 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity",
                  children: [canShare && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: "flex items-center justify-center w-7 h-7 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
                    title: "Share",
                    onClick: function onClick(e) {
                      e.stopPropagation();
                      onShareOpen(prompt, e.currentTarget);
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
                      width: 15,
                      height: 15,
                      className: "text-[#6B7280]"
                    })
                  }), canPublish && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: "flex items-center justify-center w-7 h-7 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
                    title: "Publish as Managed",
                    onClick: function onClick(e) {
                      e.stopPropagation();
                      onPublishPrompt(prompt);
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UploadIcon, {
                      width: 15,
                      height: 15,
                      className: "text-[#6B7280]"
                    })
                  }), canEdit && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: "flex items-center justify-center w-7 h-7 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
                    title: "Edit",
                    onClick: function onClick(e) {
                      e.stopPropagation();
                      onViewPrompt(prompt);
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
                      width: 15,
                      height: 15,
                      className: "text-[#6B7280]"
                    })
                  }), canDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: "flex items-center justify-center w-7 h-7 rounded hover:bg-[#FEE4E2] cursor-pointer bg-transparent border-none",
                    title: "Delete",
                    onClick: function onClick(e) {
                      e.stopPropagation();
                      onDeletePrompt(prompt);
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
                      width: 15,
                      height: 15,
                      className: "text-[#6B7280]"
                    })
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "[grid-area:1/1] group-hover:invisible group-focus-within:invisible",
                  children: getPromptTypeIcon(prompt)
                })]
              })]
            }, prompt.id);
          })
        })]
      }, category);
    }), prompts.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-center py-2 text-[#686766] text-[13px]",
      children: "End of list"
    })]
  });
};
var _default = exports.default = PromptsTab;